enum AgencyBilledQuantity {
  Partial = 'Partial',
  All = 'All',
  None = 'None',
}

export default AgencyBilledQuantity;
